/**
 * Standard playing cards, stored as plain numbers 0..51 so a whole shoe
 * serializes compactly into the saved run. rank = n % 13 (0 = Ace ... 12 =
 * King), suit = floor(n / 13).
 */
export type Card = number;

/**
 * Suit glyphs aren't confirmed to exist in the G2's font yet. If they render
 * as blanks or boxes on real hardware, flip this to false for letter suits
 * (As Kh) — one switch, every game follows.
 */
export const USE_SUIT_GLYPHS = true;

const RANKS = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];
const SUIT_GLYPHS = ['♠', '♥', '♦', '♣'];
const SUIT_LETTERS = ['s', 'h', 'd', 'c'];

export function rankOf(card: Card): number {
  return card % 13;
}

export function suitOf(card: Card): number {
  return Math.floor(card / 13);
}

export function cardLabel(card: Card): string {
  const suits = USE_SUIT_GLYPHS ? SUIT_GLYPHS : SUIT_LETTERS;
  return `${RANKS[rankOf(card)]}${suits[suitOf(card)]}`;
}

export function newDecks(count: number): Card[] {
  const cards: Card[] = [];
  for (let d = 0; d < count; d++) for (let c = 0; c < 52; c++) cards.push(c);
  return cards;
}
